// extracted by mini-css-extract-plugin
module.exports = {"partner":"Partners_partner__kJpga","partnerImages":"Partners_partnerImages__rxGVF"};